import type { GaApp } from '~/modules/app'

export const getters = (gaApp: GaApp) => ({})
